/**
 * Resolves after `ms` milliseconds. Typically used to let a mutation settle on
 * the backend before invalidating queries.
 */
export const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
